module.exports = __webpack_public_path__ + "img/6.4be5070b.png";